import { RefreshCw, X } from 'lucide-react'
import { useServiceWorker } from '@/hooks/useServiceWorker'
import { cn } from '@/lib/utils'

/**
 * Erscheint als fixierter Banner am oberen Rand, wenn ein App-Update verfügbar ist.
 * Klick auf "Jetzt aktualisieren" aktiviert den neuen Service Worker und lädt die App neu.
 * Spiegelt das Verhalten der PWA, damit Nutzer nach einem Deploy nicht den Cache leeren müssen.
 */
export function UpdateBanner({ className }: { className?: string }) {
  const { needsUpdate, updateNow, dismiss } = useServiceWorker()

  if (!needsUpdate) return null

  return (
    <div
      className={cn(
        'fixed left-0 right-0 top-0 z-[100]',
        'flex items-center gap-3 px-4 py-3',
        'bg-primary text-primary-foreground shadow-lg',
        className,
      )}
      role="alert"
    >
      <RefreshCw size={16} className="shrink-0" />

      <p className="flex-1 text-sm font-medium">Neue Version verfügbar</p>

      <button
        onClick={updateNow}
        className="shrink-0 rounded-md bg-white/20 px-3 py-1 text-xs font-semibold transition-colors hover:bg-white/30 active:bg-white/40"
      >
        Jetzt aktualisieren
      </button>

      <button
        onClick={dismiss}
        className="shrink-0 rounded-md p-1 transition-colors hover:bg-white/20"
        aria-label="Schließen"
      >
        <X size={15} />
      </button>
    </div>
  )
}
